module.exports = __webpack_public_path__ + "assets/img/btn_fasong.289cde29.png";